import ManageUsers from './ManageUsers';

export default {
  ManageUsers,
};
